import { toCurrencyTruncated } from '@simplywallst/formatting';

type Unit = 'total compensation' | 'salary' | 'company earnings';

export const getUnitValue = ({
  unit,
  value,
  currencyISO,
  reportingUnit,
}: {
  unit: Unit;
  value: number;
  currencyISO: string;
  reportingUnit: number;
}) => {
  if (unit === 'company earnings')
    return toCurrencyTruncated(value * reportingUnit, 0, currencyISO);
  return toCurrencyTruncated(value, 0, currencyISO);
};
